import { updateEntity } from "@/store";
import { useSimulatorState } from "modules/simulator-state/simulatorStateHooks";
import { useEffect } from "react";
import { updateEntities } from "redux-query";
import { TimerStatus } from "types/enums";
import { useAppDispatch } from "utils/hooks";
import { subtractSecondsFromTimerArray } from "utils/timer/timerHelpers";

type CountdownTimerProps = {
  simulatorId: string;
};
const CountdownTimer: React.FC<CountdownTimerProps> = (props) => {
  const dispatch = useAppDispatch();
  const [simulatorState] = useSimulatorState(props.simulatorId);

  const tick = () => {
    if (simulatorState && simulatorState.timerStatus === TimerStatus.RUNNING) {
      dispatch(
        updateEntities({
          simulatorStates: updateEntity(props.simulatorId, (existing) => ({
            timerStatus: existing.timerStatus,
            timerValue: subtractSecondsFromTimerArray(existing.timerValue, 1),
          })),
          // simulatorStates: (prev) => {
          //   const existing = prev[props.simulatorId];
          //   if (!existing) return prev;

          //   return {
          //     ...prev,
          //     [props.simulatorId]: {
          //       ...existing,
          //       timerStatus: existing.timerStatus,
          //       timerValue: subtractSecondsFromTimerArray(existing.timerValue, 1),
          //     },
          //   };
          // },
        }),
      );
    }
  };

  useEffect(() => {
    const timerId = setInterval(() => tick(), 1000);
    return () => clearInterval(timerId);
  });

  return null;
};

export default CountdownTimer;
